import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./Pages/LoginPage";
import UserDashboard from "./Pages/UserDashboard";
import ForgotPasswordPage from "./Pages/forgetPassword";
import { ToastContainer } from "react-toastify";
import { CustomerProvider } from "./context/customerContext";
import ProtectedRoute from "./components/ProtectedRoute";
import "react-toastify/dist/ReactToastify.css";
import Customer from "./Pages/Customer";
import Product from "./Pages/Product";
import Employee from "./Pages/Employee";
import { AppProvider } from "./context/AppContext";
import Layout from "./Pages/Layout";
import Profile from "./Pages/profile";
import GroupingManagement from "./Pages/GroupingManagement";
import { LanguageProvider } from "./Pages/LanguageContext";
import Order from "./Pages/Order";
import ProductPrice from "./Pages/ProductPrice";
import Role from "./Pages/Role"

function App() {
  useEffect(() => {
    const preventGesture = (e) => {
      e.preventDefault();
    };

    document.addEventListener("gesturestart", preventGesture);
    document.addEventListener("gesturechange", preventGesture);
    document.addEventListener("gestureend", preventGesture);

    return () => {
      document.removeEventListener("gesturestart", preventGesture);
      document.removeEventListener("gesturechange", preventGesture);
      document.removeEventListener("gestureend", preventGesture);
    };
  }, []);

  return (
    <LanguageProvider>
    <Router>
      <AppProvider>
        <CustomerProvider>
          <ToastContainer rtl position="top-center" autoClose={3000} />
          <Routes>
            {/* مسیر لاگین */}
            {["/", "/login"].map((path) => (
              <Route key={path} path={path} element={<LoginPage />} />
            ))}

            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route
              path="/customer"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Customer />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/GroupingManagement"
              element={
                <ProtectedRoute>
                   <Layout>
                    <GroupingManagement />
                   </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/ProductPrice"
              element={
                <ProtectedRoute>
                   <Layout>
                    <ProductPrice />
                   </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/Role"
              element={
                <ProtectedRoute>
                   <Layout>
                    <Role />
                   </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/order"
              element={
                <ProtectedRoute>
                   <Layout>
                    <Order />
                   </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/product"
              element={
                <ProtectedRoute>
                  <Layout>
                  <Product />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Layout>
                    <UserDashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/employee"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Employee />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Profile />
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </CustomerProvider>
      </AppProvider>
    </Router>
    </LanguageProvider>
  );
}

export default App;
